import { countryCodeParser, CountryCodeParser } from '../utilities/address/country-code';

export class AddressUtilityHandler {
    private _countryCodeParser: CountryCodeParser;

    constructor() {
        this._countryCodeParser = countryCodeParser();
    }

    get countryCodeParser(): CountryCodeParser {
        return this._countryCodeParser;
    }
}
